import angular from 'angular';
import uibModal from 'angular-ui-bootstrap/src/modal';
import gettext from 'angular-gettext';
import MediaResource from '../../MediaModules/MediaResource';
import mediaPickerModal from '../../MediaModules/MediaPickerModal/MediaPickerModal';

/**
 * @memberOf cms.input.media
 * @property {object}   bindings.errors       Form errors object
 * @property {string}   bindings.label        Input label and/or placeholder
 * @property {string}   bindings.helper       Helper message for input
 * @property {string}   bindings.buttonTitle  Button label, default "Choose file"
 * @property {array}    bindings.mediaModel        Model array reference
 * @property {object}   bindings.extraFields  Function that returns promise if slug is valid
 * @property {boolean}  bindings.multiple     Allow to select multiple media
 * @property {string}   bindings.aclShow      ACL config - show input
 * @property {string}   bindings.aclDisable   ACL config - disable input
 * @property {string}   bindings.labelSize    Label column size (1-12)
 * @property {string}   bindings.inputSize    Input column size (1-12)
 */
let cmsButtonLink = {
    template: require('./buttonLink.html'),
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        placeholder: '@',
        buttonTitle: '@',
        model: '=',
        extraFields: '<',
        multiple: '<',
        aclShow: '<?',
        aclDisable: '<?'
    },

    controller: function ($scope, $uibModal, MediaPickerModal) {

        this.$onInit = () => {
            this.selectedMedia = [];
            if(!this.mediaModel) {
                this.mediaModel = [];
            }
        };

        /**
         * Used from in the modal to remember current selection
         *
         * @private
         * @param {MediaResource} media
         * @param {boolean} selected
         */
        this.onMediaSelected = (media, selected) => {

            if(this.multiple) {
                if (selected) {
                    this.selectedMedia.push(media);
                } else {
                    this.selectedMedia = this.selectedMedia.filter(function (mediaUsage) {
                        return mediaUsage.id !== media.id;
                    });
                }
            } else {
                this.selectedMedia = selected ? [media] : [];
            }

        };

        this.openMediaPickerModal = () => {

            MediaPickerModal.open(this.multiple).result.then(selectedMedia => {
                selectedMedia.forEach((el) => {
                    let exists = this.mediaModel.filter(existing => {
                        return existing.media.id === el.id;
                    }).length >= 1;

                    if (!exists) {
                        if (this.multiple) {
                            this.mediaModel.push({
                                media: angular.copy(el)
                            });
                        } else {
                            this.mediaModel = [{media: angular.copy(el)}];
                        }
                    }
                    this.model = '/image/0x0/' + this.mediaModel[0].media.key;
                }, this);

                $scope.$emit('content-changed');
            });
        };
    }
};

/**
 * Media control
 * @namespace cms.input.media
 */
export default angular.module('cms.input.button.link', [uibModal, gettext, mediaPickerModal, MediaResource])
    .component('cmsInputButtonLink', cmsButtonLink).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/ButtonLinkControl/CmsButtonLink.js